import React, { useMemo } from 'react'
import View from './view.js'

import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
  startOfYear,
  endOfYear,
  subWeeks,
  subMonths,
  subQuarters,
  subYears,
} from 'date-fns'

export default function Logic(props) {
  let rangeTemplates = useMemo(() => {
    let today = new Date()
    let lastWeek = subWeeks(today, 1)
    let lastMonth = subMonths(today, 1)
    let lastQuarter = subQuarters(today, 1)
    let lastYear = subYears(today, 1)

    return [
      {
        id: 'CUSTOM',
        text: 'Custom',
      },
      {
        id: 'THIS_WEEK',
        text: 'This week',
        from: startOfWeek(today),
        to: endOfWeek(today),
      },
      {
        id: 'LAST_WEEK',
        text: 'Last week',
        from: startOfWeek(lastWeek),
        to: endOfWeek(lastWeek),
      },
      {
        id: 'THIS_MONTH',
        text: 'This month',
        from: startOfMonth(today),
        to: endOfMonth(today),
      },
      {
        id: 'LAST_MONTH',
        text: 'Last month',
        from: startOfMonth(lastMonth),
        to: endOfMonth(lastMonth),
      },
      {
        id: 'THIS_QUARTER',
        text: 'This quarter',
        from: startOfQuarter(today),
        to: endOfQuarter(today),
      },
      {
        id: 'LAST_QUARTER',
        text: 'Last quarter',
        from: startOfQuarter(lastQuarter),
        to: endOfQuarter(lastQuarter),
      },
      {
        id: 'THIS_YEAR',
        text: 'This year',
        from: startOfYear(today),
        to: endOfYear(today),
      },
      {
        id: 'LAST_YEAR',
        text: 'Last year',
        from: startOfYear(lastYear),
        to: endOfYear(lastYear),
      },
    ]
  }, [])

  return <View {...props} rangeTemplates={rangeTemplates} />
}
